<ifb-card>
  <mat-card appearance="raised"
            *ngIf="isNPLLoan() && !accessNPLEconomics">
    <mat-card-header class="card-header">
      <mat-card-title class="card-header__frozen">
        This account is frozen. Message has been sent to customer to contact our Legal department at legal&#64;ideafinancial.com.
      </mat-card-title>
    </mat-card-header>
  </mat-card>


  <mat-card appearance="raised"
            *ngIf="!isNPLLoan() || accessNPLEconomics">
    <mat-card-header class="card-header">
      <mat-card-title class="card-header__title">
        Maintenance balances
      </mat-card-title>
      <div class="header-container">
        <div class="chart-container">
          <ifc-bar-chart [data]="barChartData"
                         [options]="barChartOptions">
          </ifc-bar-chart>
          <div class="chart-label">{{label}}: {{accountState?.stateData.utilization / 100 | percent:'1.2-2'}}</div>
        </div>
        <mat-list class="mat-list-white">
          <mat-list-item>
            <span matListItemTitle>{{(accountState?.stateData.principalBalance | currency:'$') || 'Null'}}</span>
            <span matListItemLine>Principal Balance</span>
          </mat-list-item>
          <mat-list-item>
            <span matListItemTitle>{{(accountState?.stateData.accruedInterest | currency:'$') || 'Null'}}</span>
            <span matListItemLine>Accrued interest</span>
          </mat-list-item>
          <mat-list-item>
            <span matListItemTitle>{{(accountState?.stateData.paymentAmount | currency:'$') || 'Null'}}</span>
            <span matListItemLine>Payment amount</span>
          </mat-list-item>
        </mat-list>
      </div>
      <button *ngIf="edit"
              mat-mini-fab
              class="edit-button"
              color="primary"
              routerLink="balances"
              aria-label="Edit">
        <mat-icon>edit</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content class="mat-card-content-lg no-bottom-padding">
      <ifc-horizontal-list [items]="listItems"></ifc-horizontal-list>
    </mat-card-content>
  </mat-card>
</ifb-card>